import { usePermissions } from '@cobliteam/permissions';
import Button from '@cobliteam/ui/components/Button';
import Dropdown from '@cobliteam/ui/components/Dropdown';
import Icon from '@cobliteam/ui/icons';
import { baseLegendItems, itemsWhenAllowedToViewPlacesOfInterest, itemsWhenNotAllowedToViewPlacesOfInterest, type LegendItem, mediaEventItems } from './items';
import MapLegendOverlay from './MapLegendOverlay';

interface MapLegendProps {
  showMediaEvents: boolean;
}

export const MapLegend = ({ showMediaEvents }: MapLegendProps) => {
  const { isAccessAllowed } = usePermissions();
  const isAllowedToViewPlacesOfInterest = isAccessAllowed('view:places-of-interest');

  const legendItems: LegendItem[] = [
    ...baseLegendItems,
    ...(isAllowedToViewPlacesOfInterest ? itemsWhenAllowedToViewPlacesOfInterest : itemsWhenNotAllowedToViewPlacesOfInterest),
    ...(showMediaEvents ? mediaEventItems : []),
  ];

  return (
    <Dropdown overlay={<MapLegendOverlay legendItems={legendItems} />}>
      <Button variant='outlined' startIcon={<Icon name='captions' />} className='bg-white shadow hover:bg-gray-4'>
        Legenda
      </Button>
    </Dropdown>
  );
};

export default MapLegend;
